// Embed entry. One <script> tag mounts the assistant. The host page points it at
// the chat service via either a global or a data-api attribute:
//   <script>window.MarginArcAssistant = { apiBase: 'https://chat.marginarc.com' }</script>
//   <script src="https://chat.marginarc.com/widget.js" data-api="https://chat.marginarc.com"></script>

import { mountWidget } from './Widget.js';
import type { WidgetConfig } from './config.js';

declare global {
  interface Window {
    MarginArcAssistant?: Partial<WidgetConfig>;
  }
}

// currentScript is only valid while this module is first executing — capture now.
const thisScript = document.currentScript as HTMLScriptElement | null;

function boot(): void {
  const g = window.MarginArcAssistant ?? {};
  const apiBase = (g.apiBase || thisScript?.dataset.api || '').replace(/\/+$/, '');
  mountWidget({ ...g, apiBase });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
